// extracted by mini-css-extract-plugin
module.exports = {"changeProfile":"ChangeProfile_changeProfile__1jbN_","badge":"ChangeProfile_badge__3gjN1","selected":"ChangeProfile_selected__xhHeN"};